import { LegacyDataTable, LegacyDataTableBody, LegacyDataTableRowHeaderColumn, LegacyDataTableRow, LegacyDataTableRowColumn } from "@octopusdeploy/design-system-components";
import type { ServerConfigurationSettingsSetResource, ServerConfigurationSettingsValueResource } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import { repository } from "~/clientInstance";
import type { DataBaseComponentState } from "~/components/DataBaseComponent/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent/DataBaseComponent";
import { PageContent } from "~/components/PageContent/PageContent";
import { Section } from "~/components/Section/Section";
interface ServerSettingsState extends DataBaseComponentState {
    settings?: ServerConfigurationSettingsSetResource[];
}
export class ServerSettingsPage extends DataBaseComponent<{}, ServerSettingsState> {
    constructor(props: {}) {
        super(props);
        this.state = {};
    }
    async componentDidMount() {
        return this.doBusyTask(async () => {
            const settings = await repository.ServerConfiguration.settings();
            this.setState({ settings });
        });
    }
    render() {
        const valueMap = (value: ServerConfigurationSettingsValueResource) => (<LegacyDataTableRow key={value.Key}>
                <LegacyDataTableRowHeaderColumn>{value.Description}</LegacyDataTableRowHeaderColumn>
                <LegacyDataTableRowColumn>{value.Value?.toString()}</LegacyDataTableRowColumn>
            </LegacyDataTableRow>);
        const setMap = (set: ServerConfigurationSettingsSetResource) => (<Section key={set.ConfigurationSet} sectionHeader={set.ConfigurationSet}>
                <LegacyDataTable>
                    <LegacyDataTableBody>{set.ConfigurationValues.map(valueMap)}</LegacyDataTableBody>
                </LegacyDataTable>
            </Section>);
        const body = this.state.settings && <div>{this.state.settings.map(setMap)}</div>;
        return (<PageContent header={{ title: "Server Settings", breadcrumbs: [{ label: "Nodes", pageUrl: links.nodesPage.generateUrl() }] }} busy={this.state.busy} errors={this.errors}>
                {body}
            </PageContent>);
    }
    static displayName = "ServerSettingsPage";
}
